module.exports = __webpack_public_path__ + "img/56.95df13c5.jpg";